import {
  type ErrorType,
  useApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate,
  useApiOrdersV1PurchaseOrdersDocumentsUploadCreate,
} from 'api';

import { useUploadAndCreateDocument } from '../../../document';

export const useUploadAndCreatePurchaseOrderDocument = () => {
  const { mutateAsync: createDocument } = useApiOrdersV1PurchaseOrdersDocumentsUploadCreate<ErrorType<Error>>();
  const { mutateAsync: generatePreSignedURL } =
    useApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate<ErrorType<Error>>();
  return useUploadAndCreateDocument<{ slug: string }>(generatePreSignedURL, createDocument);
};
